export default __webpack_public_path__ + "static/media/profilepic2.6cb2dcee.png";